import { Directive, HostListener } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[invdTextLengthLimitation]',
})
export class TextLengthLimitationDirective {
  @HostListener('keydown', ['$event']) onKeyDown(event) {
    if ((event.which >= 37 && event.which <= 40) || event.which === 8 || event.which === 46) return;
    if (event.target.value.length > 500) {
      event.preventDefault();
    }
  }
}
